module.exports = __webpack_public_path__ + "img/ic_plane-1.9f621b63.svg";